import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfTwitterAuthBatchIconProps extends SvgIconProps  {}
/**
 * component used to display twitter auth batch icon in twitter interaction
 * @param props - CcfTwitterAuthBatchIconProps
 * @example - <CcfTwitterAuthBatchIcon />
 * @returns SVG of twitter auth batch icon in twitter interaction
 */
export function CcfTwitterAuthBatchIcon(props: CcfTwitterAuthBatchIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="ic_auth_badge" clip-path="url(#clip-ic_auth_badge)">
        <path id="Path_25522" data-name="Path 25522" d="M758.274,861.556a2.619,2.619,0,0,0-1.4-2.344,2.718,2.718,0,0,0,.156-.912,2.546,2.546,0,0,0-2.486-2.6,2.344,2.344,0,0,0-.87.162,2.441,2.441,0,0,0-4.475,0,2.339,2.339,0,0,0-.869-.162,2.545,2.545,0,0,0-2.486,2.6,2.747,2.747,0,0,0,.155.912,2.667,2.667,0,0,0-.133,4.613,2.708,2.708,0,0,0-.021.335,2.545,2.545,0,0,0,2.486,2.6,2.362,2.362,0,0,0,.869-.162,2.441,2.441,0,0,0,4.475,0,2.368,2.368,0,0,0,.87.162,2.546,2.546,0,0,0,2.486-2.6,2.707,2.707,0,0,0-.023-.335A2.63,2.63,0,0,0,758.274,861.556Zm-4.308-2.171-2.822,4.232a.489.489,0,0,1-.677.136l-.075-.061-1.572-1.572a.489.489,0,0,1,.691-.691l1.15,1.152,2.491-3.736a.489.489,0,1,1,.813.542Z" transform="translate(-743.539 -853.295)" fill="#333"/>
      </g>
    </SvgIcon>
  );
}

export default CcfTwitterAuthBatchIcon;
